import React, { useEffect, useState } from "react";
import Checkout from "../Checkout/Checkout";
import { toast } from "react-toastify";

const Bookings = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("tokenWebsite");
  const params = new URLSearchParams(window.location.search);
  const searchedValues = JSON.parse(localStorage.getItem("bookingvalues"));
  const cityId = JSON.parse(localStorage.getItem("bookingvalues"))?.cityId;
  const startParam = JSON.parse(
    localStorage.getItem("bookingvalues"),
  )?.startDate;
  const endParam = JSON.parse(localStorage.getItem("bookingvalues"))?.endDate;
  const pickupTime = JSON.parse(
    localStorage.getItem("bookingvalues"),
  )?.pickupTime;
  const dropTime = JSON.parse(localStorage.getItem("bookingvalues"))?.dropTime;
  const vehicleId = JSON.parse(
    localStorage.getItem("bookingvalues"),
  )?.vehicleId;
  const source = JSON.parse(localStorage.getItem("bookingvalues"))?.source;
  const packageId = JSON.parse(
    localStorage.getItem("bookingvalues"),
  )?.packageId;
  const customerId =
    JSON.parse(localStorage.getItem("bookingvalues"))?.customerId ||
    localStorage.getItem("id");
  const groupId = JSON.parse(localStorage.getItem("bookingvalues"))?.groupId;
  const seater = JSON.parse(localStorage.getItem("bookingvalues"))?.seating;
  const tramissiontype = (() => {
    const bv = JSON.parse(localStorage.getItem("bookingvalues")) || {};
    return bv.tramissiontype || bv.transmissiontype || null;
  })();
  const fuelType = JSON.parse(localStorage.getItem("bookingvalues"))?.fuelType;
  const bodyTypeText = JSON.parse(localStorage.getItem("bookingvalues"))?.bodyTypeText;
  const freekm = JSON.parse(localStorage.getItem("bookingvalues"))?.freekm;
  const extraKm = JSON.parse(localStorage.getItem("bookingvalues"))?.extraKm;
  const hubid = JSON.parse(localStorage.getItem("bookingvalues"))?.hubid;
  const plankm = JSON.parse(localStorage.getItem("bookingvalues"))?.plankm;
  const isSubscription = JSON.parse(localStorage.getItem("bookingvalues"))?.isSubscription || false;
  const bookingType = JSON.parse(localStorage.getItem("bookingvalues"))?.bookingType || null;
  const savedImageUrl = JSON.parse(localStorage.getItem("bookingvalues"))?.imageUrl || "";
  const savedBodyType = JSON.parse(localStorage.getItem("bookingvalues"))?.bodyTypeText || "";
  const [carData, setCarData] = useState();
  const [cityname, setcityname] = useState("");
  const [citydata, setcitydata] = useState([]);
  const [cityid, setcityid] = useState(1);
  const [airportdata, setairportdata] = useState([]);
  const [airportDelivery, setAirportDelivery] = useState(false);
  const [pickup, setPickup] = useState("");
  const [drop, setDrop] = useState("");
  const [hubname, sethubname] = useState("");
  const [deliverytype, setdeliverytype] = useState("Self Pickup");
  const [isSelf, setisself] = useState(true);
  const [isclicked, setisclicked] = useState(false);
  const [dropcharges, setdropcharges] = useState(null);
  const [dropcharges2, setdropcharges2] = useState(null);
  const [isdropclicked, setisdropclicked] = useState(false);
  const [dropOption, setDropOption] = useState("select");
  const [couponpostresponse, setcouponpostresponse] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const startDateObj = new Date(startParam);
  const startDate = `${startDateObj.getFullYear()}-${(
    startDateObj.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${startDateObj.getDate().toString().padStart(2, "0")}`;

  function getDurationString(start, end) {
    const startTime = new Date(start);
    const endTime = new Date(end);
    const diffMs = endTime - startTime;

    if (isNaN(diffMs) || diffMs <= 0) return "Invalid duration";

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    return `${days} days ${hours} hours ${minutes} minutes`;
  }

  function formatToDateTime(dateString, timeString) {
    if (!dateString || !timeString) return null;

    // Ensure time string is trimmed
    const trimmedTime = timeString.trim();
    // Convert time to 24-hour format
    const [time, modifier] = trimmedTime.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    const formattedDate = new Date(dateString);
    const year = formattedDate.getFullYear();
    const month = `${formattedDate.getMonth() + 1}`.padStart(2, "0");
    const day = `${formattedDate.getDate()}`.padStart(2, "0");
    const formattedHours = `${hours}`.padStart(2, "0");
    const formattedMinutes = `${minutes}`.padStart(2, "0");

    return `${year}-${month}-${day}T${formattedHours}:${formattedMinutes}`;
  }

  const endDateObj = new Date(endParam);

  const endDate = `${endDateObj.getFullYear()}-${(endDateObj.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${endDateObj.getDate().toString().padStart(2, "0")}`;

  const formattedStartDate = isSubscription ? startParam : formatToDateTime(startDate, pickupTime);
  const formattedEndDate = isSubscription ? endParam : formatToDateTime(endDate, dropTime);

  const duration = getDurationString(formattedStartDate, formattedEndDate);

  useEffect(() => {
    if (
      searchedValues === null ||
      Object.keys(searchedValues).length === 0 ||
      !searchedValues
    ) {
      window.location.href = "/";
    }
  }, [searchedValues]);

  useEffect(() => {
    const getairportsdata = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/api/cityairports?cityId=${cityId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
        );

        const data = await response.json();
        if (data.statusCode === "0100") {
          setairportdata(data?.entities?.rows);
        }
      } catch (error) {
        console.error("Error fetching airport data:", error);
      }
    };

    getairportsdata();
  }, []);

  const getcardetails = async () => {
    try {
      let url;
      if (isSubscription) {
        url = `${apiUrl}/api/subscriptionbookings/generate-inquires?startDate=${startParam}&endDate=${endParam}&packageId=${packageId}&cityId=${cityId}&customerId=${customerId}&groupId=${groupId}&vehicleId=${vehicleId}&source=${source}&hubId=${hubid}&bookingType=${bookingType}`;
      } else {
        url = `${apiUrl}/api/v2/vehicle-bookings-v2/generate-online-inquiry?startDate=${formattedStartDate}&endDate=${formattedEndDate}&packageId=${packageId}&cityId=${cityId}&hubId=${hubid}&customerId=${customerId}&groupId=${groupId}&vehicleId=${vehicleId}&source=${source}${bookingType ? `&bookingType=${bookingType}` : ""}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();

      if (data?.statusCode === "0100") {
        setCarData(data?.dataValues);
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error fetching car Details:", error);
    }
  };

  useEffect(() => {
    const fetchCity = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/cities`);
        const data = await response.json();

        if (data?.statusCode === "0100") {
          const sortedData = data.entities.rows.sort((a, b) =>
            a.name.localeCompare(b.name),
          );
          setcitydata(sortedData);
          const matchedCity = sortedData.find(
            (city) => city.id === Number(cityId),
          );

          if (matchedCity) {
            const cityName = matchedCity.name;
            setcityname(cityName);
          }
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchCity();

    getcardetails();
  }, []);

  useEffect(() => {
    const fetchhubdetails = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/api/hubs?limit=100&cityId=${cityId}`,
        );
        const data = await response.json();

        if (data?.statusCode === "0100") {
          const sortedData = data.entities.rows.sort(
            (a, b) => a.cityId - b.cityId,
          );
          const matchedHub = sortedData.find(
            (city) => city.id === Number(hubid),
          );

          if (matchedHub) {
            const hubName = matchedHub.hubAddress;
            setPickup(hubName);
            sethubname(hubName);
          }
        }
      } catch (error) {
        console.error("Error fetching hub details:", error);
      }
    };

    fetchhubdetails();
  }, []);

  const getdeliverychargesforpickup = async () => {
    // hub executive will drop car to the customers
    if (airportDelivery.length > 0 || pickup.length > 0) {
      try {
        const response = await fetch(
          `${apiUrl}/api/deliverypickup/calculatedeliverycharges`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `${token}`,
            },
            body: JSON.stringify({
              cityId: cityId,
              hubId: hubid,
              endPoint: pickup,
              isSelf: isSelf,
              isAirportDelivery: airportDelivery,
              costToCustomer: carData?.costToCustomer,
              deliveryCharges: carData?.deliveryCharges,
            }),
          },
        );
        const data = await response.json();

        if (data?.statusCode === "0100") {
          setdropcharges(data?.dataValues);
          setisclicked(false);
        } else {
          console.error("Unexpected API response:", data);
          setisclicked(false);
        }
      } catch (error) {
        console.error("Error fetching rental packages:", error);
      }
    }
  };

  useEffect(() => {
    if (
      pickup.length > 0 &&
      carData?.costToCustomer !== undefined &&
      deliverytype === "Self Pickup"
    ) {
      getdeliverychargesforpickup();
    }
  }, [pickup, carData]);
  

  const getdeliverychargesfordrop = async () => {
    let payload = {
      cityId: cityId,
      hubId: hubid,
      endPoint: drop,
      isAirportDelivery:
        dropOption === "sameaspickup" && airportDelivery ? true : false,
      isSelf:
        dropOption === "sameaspickup" && deliverytype === "Self Pickup"
          ? true
          : false,
      costToCustomer: dropcharges?.costToCustomer,
      pickupCharges: carData?.pickupCharges,
      deliveryCharges: dropcharges && dropcharges?.deliveryCharges,
    };

    if (!payload?.costToCustomer) {
      toast.error("please make sure the network is stable refresh the page and try again");
      return;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/deliverypickup/calculatepickupcharges`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        },
      );
      const data = await response.json();

      if (data?.statusCode === "0100") {
        setdropcharges2(data?.dataValues);
        setisdropclicked(false);
      } else {
        console.error("Unexpected API response:", data);
        setisdropclicked(false);
      }
    } catch (error) {
      console.error("Error fetching delivery charges for drop:", error);
    }
  };

  useEffect(() => {
    if (airportDelivery || isclicked) {
      getdeliverychargesforpickup();
    }
  }, [isclicked, airportDelivery]);
  useEffect(() => {
    if (isdropclicked) {
      getdeliverychargesfordrop();
    }
  }, [isdropclicked]);
  useEffect(() => {
    if (deliverytype === "Home Delivery" && isdropclicked) {
      getdeliverychargesfordrop();
    }
  }, [drop]);

  return (
    <div className="w-full px-4 md:px-8 pt-[74px] pb-4 bg-[#FFFAF9]">
      <h2 className="hidden md:block md:mt-2 font-semibold text-xl md:text-3xl mb-6">
        Review &amp; Checkout
      </h2>
      <Checkout
        airportdata={airportdata}
        citydata={citydata}
        cityid={cityid}
        cityId={cityId}
        cityname={cityname}
        hubid={hubid}
        airportDelivery={airportDelivery}
        setAirportDelivery={setAirportDelivery}
        pickup={pickup}
        setPickup={setPickup}
        drop={drop}
        setDrop={setDrop}
        getdeliverychargesforpickup={getdeliverychargesforpickup}
        carData={carData}
        sethubname={sethubname}
        hubname={hubname}
        setdeliverytype={setdeliverytype}
        deliverytype={deliverytype}
        setisself={setisself}
        setisclicked={setisclicked}
        dropcharges={dropcharges}
        setisdropclicked={setisdropclicked}
        dropcharges2={dropcharges2}
        setDropOption={setDropOption}
        dropOption={dropOption}
        getdeliverychargesfordrop={getdeliverychargesfordrop}
        formattedStartDate={formattedStartDate}
        formattedEndDate={formattedEndDate}
        setcouponpostresponse={setcouponpostresponse}
        couponpostresponse={couponpostresponse}
        getcardetails={getcardetails}
        setdropcharges2={setdropcharges2}
        setdropcharges={setdropcharges}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        seater={seater}
        fuelType={fuelType}
        tramissiontype={tramissiontype}
        freekm={freekm}
        extraKm={extraKm}
        plankm={plankm}
        duration={duration}
        isSubscription={isSubscription}
        savedImageUrl={savedImageUrl}
        savedBodyType={savedBodyType}
      />
    </div>
  );
};

export default Bookings;
